/**
 * Lockup — the logo art already contains the "nMach" wordmark, so no text
 * runs beside it; only the product qualifier ("Portal") does.
 */
export function Logo({ className = '' }: { className?: string }) {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <img
        src="/brand/nmach-logo.png"
        alt="nMach"
        width={900}
        height={353}
        className="h-8 w-auto"
      />
      <span className="rounded-full border border-cobalt/30 px-2 py-0.5 text-[0.6875rem] font-medium uppercase tracking-widest text-cobalt">
        Portal
      </span>
    </span>
  )
}
